"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GLFilter = _interopRequireDefault(require("./GLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class GLSquareCropRotateFilter extends _GLFilter.default {
  constructor() {
    const fsSource = `
        precision mediump float;
        varying highp vec2 v_uv;

        uniform sampler2D t_tex;
        
        uniform float aspectRatio;
        uniform float scale;
        uniform vec2 offset;
        uniform vec2 rotation;
        
        void main() {
            vec2 uv = (v_uv + offset);
	        uv.y = 1.0 - uv.y;
	        
	        vec2 translatedUV = uv - vec2(0.5, 0.5);
	        vec2 rotatedUV = vec2(
                translatedUV.x * rotation.y + translatedUV.y * rotation.x,
                translatedUV.y * rotation.y - translatedUV.x * rotation.x);
            vec2 scaledUV = rotatedUV / scale;
            if (aspectRatio > 1.0) {
                scaledUV = vec2(scaledUV.x / aspectRatio, scaledUV.y);
            } else {
                scaledUV = vec2(scaledUV.x, scaledUV.y * aspectRatio);
            }
            vec2 finalUV = scaledUV + vec2(0.5, 0.5);

	        if (0.0 <= finalUV.x && finalUV.x <= 1.0 
	            && 0.0 <= finalUV.y && finalUV.y <= 1.0) {
	            gl_FragColor = texture2D(t_tex, finalUV);
	        } else {
	            gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
            }
        }
        `;
    super(fsSource);
    this._rotationInDegrees = 0.0;
    this._aspectRatio = 1.0;
    this._scale = 1.0;
    this._offset = [0.0, 0.0];
    this._rotation = [0.0, 1.0];
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.aspectRatio = gl.getUniformLocation(program, 'aspectRatio');
    uniformLocations.scale = gl.getUniformLocation(program, 'scale');
    uniformLocations.offset = gl.getUniformLocation(program, 'offset');
    uniformLocations.rotation = gl.getUniformLocation(program, 'rotation');
    return uniformLocations;
  }

  willDraw(gl, uniformLocations, attributeLocations, flip) {
    super.willDraw(gl, uniformLocations, attributeLocations, flip);
    gl.uniform1f(uniformLocations.aspectRatio, this._aspectRatio);
    gl.uniform1f(uniformLocations.scale, this._scale);
    gl.uniform2fv(uniformLocations.offset, this._offset);
    gl.uniform2fv(uniformLocations.rotation, this._rotation);
  }

  onSizeChanged(gl, textureCords, textureWidth, textureHeight) {
    this._aspectRatio = textureWidth * 1.0 / textureHeight;
    return textureCords;
  }

  setScale(value) {
    this._scale = value;
  }

  getScale() {
    return this._scale;
  }

  setOffset(value) {
    this._offset = [-value[0], value[1]];
  }

  getOffset() {
    return [-this._offset[0], this._offset[1]];
  }

  setRotation(angleInDegrees) {
    this._rotationInDegrees = angleInDegrees;
    const rotationInRadians = angleInDegrees * Math.PI / 180.0;
    this._rotation[0] = Math.sin(rotationInRadians);
    this._rotation[1] = Math.cos(rotationInRadians);
  }

  getRotation() {
    return this._rotationInDegrees;
  }

  get outputTextureWidth() {
    return Math.min(this.width, this.height);
  }

  get outputTextureHeight() {
    return Math.min(this.width, this.height);
  }

}

exports.default = GLSquareCropRotateFilter;